export default "__VITE_ASSET__DKWV1L_Y__"